module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Black.6dab9748.ttf";